<template>
     <div class="box-res" :class="{ 'animClass' : $route.params.path1 === 'cartstep1' && !this.$store.state.main.enabelButton }">
              <img src="@/assets/img/borderDesktop.png" v-if="!gift_matched" />
              <img src="@/assets/img/borderDesktop2.png" v-if="gift_matched" />
              <img src="@/assets/img/borderTablet.png" v-if="gift_matched" />
              <img src="@/assets/img/borderTabletGift.png" v-if="!gift_matched" />
              <img src="@/assets/img/borderMobileGift.png" v-if="!gift_matched" />
              <img src="@/assets/img/borderMobile.png" v-if="gift_matched" />
              <img src="@/assets/img/borderMobile2Gift.png" v-if="!gift_matched"/>
              <img src="@/assets/img/borderMobile2.png" v-if="gift_matched">
              <div class="data-cont">
              <p class="title bold-italic wc">{{ $fn.tr('შეკვეთა') }}</p>
              <div class="adress-price-cont" v-if="$route.params.path1 === 'adress'">
                <p class="ttl light-italic wc">{{ $fn.tr('მიწოდების ღირებულება') }}</p>
                <p class="prc bold-italic wc">{{ getDeliveryPrice }} ₾</p>
              </div>
              <div class="gift" v-if="gift !== undefined && $route.params.path1 !== 'cartstep1' &&  !gift_matched">
                <p class="ttl light-italic wc">{{ $fn.tr('გააყოლე ჟუჟუნა') }}</p>
                <div class="inner-g">
                  <div class="check-cont">
                    <div class="icon-check">
                        <svg xmlns="http://www.w3.org/2000/svg" width="26.049" height="25.814" viewBox="0 0 26.049 25.814">
                        <path id="Path_3761" data-name="Path 3761" d="M5045.045-19485.148c-.527,1.859-.437,6.586-.59,9.594s-.309,11.18.463,12.514,9.044.045,11.858,0,10.585.252,11.111-1.5a25.112,25.112,0,0,0,.321-7.691c-.194-3.16-.042-10.977-1.138-12.578s-8.656-1.031-11.869-1.3S5045.571-19487.008,5045.045-19485.148Z" transform="translate(-5043.273 19487.354)" fill="none" stroke="#101820" stroke-width="2"/>
                        </svg>
                    </div>
                     <el-checkbox v-model="giftCheck">
                          <div class="checkicon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="14.066" height="14.174" viewBox="0 0 14.066 14.174">
                              <g id="Group_1851" data-name="Group 1851" transform="matrix(0.978, 0.208, -0.208, 0.978, -291.853, -423.135)">
                                  <path id="Path_218" data-name="Path 218" d="M.426,1.166C2.573.7,4.748,1.208,6.9.912c.547-.075.866-1.005.129-.9C4.876.3,2.706-.2.555.263.02.378-.308,1.325.426,1.166Z" transform="matrix(0.829, 0.559, -0.559, 0.829, 376.489, 359.997)" fill="#101820" stroke="#101820" stroke-width="1"/>
                                  <path id="Path_220" data-name="Path 220" d="M12.139.1a12.457,12.457,0,0,1-5,.486C5.169.5,3.2.389,1.255.125.332,0-.669,1.055.6,1.227a56.735,56.735,0,0,0,7.106.5A13.976,13.976,0,0,0,12.973.99C14.133.528,13.094-.281,12.139.1Z" transform="translate(386.839 351.98) rotate(109)" fill="#101820" stroke="#101820" stroke-width="1"/>
                              </g>
                              </svg>
                          </div>
                      </el-checkbox>
                  </div>
                  <div class="image">
                    <img src="@/assets/img/resultBorder.png" class="bg" />
                    <div class="img">
                    <img :src="_.get(gift, 'images.0.url')" :alt="_.get(gift, 'images.0.title')" class="bottle" />
                    </div>
                  </div>
                  <div class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15.329" height="11.574" viewBox="0 0 15.329 11.574">
                      <g id="Group_3521" data-name="Group 3521" transform="translate(-1363.467 -464.159)">
                        <path id="Path_4292" data-name="Path 4292" d="M.629,2.683c2.624.123,5.188-.506,7.8-.52,1.6-.008,3.347.329,4.9-.257A1.082,1.082,0,0,0,14.165.859l0-.075c-.025-.6-.864-.593-1.442-.227C11.3.955,9.681.533,8.25.6c-2.3.111-4.577.619-6.894.51C.559,1.074-.721,2.619.629,2.683Z" transform="matrix(-0.998, -0.07, 0.07, -0.998, 1378.111, 468.369)" fill="#044b30" stroke="#044b30" stroke-width="1"/>
                        <path id="Path_4293" data-name="Path 4293" d="M.629,2.683c2.624.123,5.188-.506,7.8-.52,1.6-.008,3.347.329,4.9-.257A1.082,1.082,0,0,0,14.165.859l0-.075c-.025-.6-.864-.593-1.442-.227C11.3.955,9.681.533,8.25.6c-2.3.111-4.577.619-6.894.51C.559,1.074-.721,2.619.629,2.683Z" transform="matrix(-0.998, -0.07, 0.07, -0.998, 1378.111, 475.505)" fill="#044b30" stroke="#044b30" stroke-width="1"/>
                      </g>
                    </svg>
                  </div>
                  <div class="gift-price-cont">
                  <!-- <p class="old-price light-italic" v-if="_.get(gift, 'oldprice') > 0">{{ _.get(gift, 'oldprice') }} ₾</p> -->
                  <p class="gift-price light-italic wc">{{ getgiftPrice * gift_amount }} ₾</p>
                  </div>
                </div>
                  <div class="amount" 
                    v-if="gift !== undefined && $route.params.path1 !== 'cartstep1' &&  !gift_matched"
                  >
             <span class="f-16 light-italic ttl wc">{{ $fn.tr('რაოდენობა') }}:</span>
                <div class="inner">
                <el-input-number v-model="gift_amount" :min="1" :max="1000"></el-input-number>      
            </div>   
        </div>
              </div>
              <div class="inner">
              <p class="desc light-italic wc">{{ $fn.tr('ჯამური ღირებულება') }}</p>
              <p class="result bold-italic wc">{{ getPrice }} ₾</p>
              </div>
              <button class="next" v-if="$route.params.path1 !== 'adress'" @click="buy" :class="{ 'disableClass' : this.$store.state.main.enabelButton && $route.params.path1 === 'cartstep1' || this.$store.state.main.zero}" >
                <img src="@/assets/img/buybtn.png" />
                <span class="regular wc">{{ $fn.tr('გაგრძელება') }}</span>
              </button>
              <button class="next" v-if="$route.params.path1 === 'adress'" @click="buyReal" :class="{ 'disableClass' : this.$store.state.main.currentAdress === null }" >
                <img src="@/assets/img/buybtn.png" />
                <span class="regular wc">{{ $fn.tr('ყიდვა') }}</span>
              </button>
              </div>
        </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    gift: {

    },
    contentData: {
      type: Object,
    }
  },
    data() {
        return {
          addressArr: [],
          clickEvent: false,
          giftCheck: false,
          gift_matched: false,
          gift_amount: 1,
          data: {
            cart: [],
         
            giftItem: null,
            giftStatus: false,
            userInfo: null,
            checkedAdress: null,
          }
        }
    },
    methods: {
    
      buyReal() {
        this.sendData()
        setTimeout(() => {
          
        }, 5000);
      },
      async sendData() {
        if (this.$store.state.main.currentAdress !== null) {
          this.data.checkedAdress = this.$store.state.main.currentAdress 
        } else {
          this.data.checkedAdress = this.addressArr
        }
        this.data.cart = JSON.parse(localStorage.getItem('Product'))
        this.data.userInfo = localStorage.getItem('userToken')
        this.data.giftItem = JSON.parse(localStorage.getItem('giftItem'))
        let tmp =  await this.$fn.postData('main/SendOrder', this.data);
        if (tmp.status === 200) {
          window.location.href = tmp.data.bank.redirect_url
        }
      },
      buy() {
        if (this.$store.state.main.userData !== null) {
          localStorage.setItem('fullBalance', this.getPrice)

          this.$store.state.main.locale == 'ge' ? this.$router.push('/ge/adress')
          : this.$router.push('/en/adress');
        } else {
          localStorage.setItem('fullBalance', this.getPrice)
          this.$store.state.main.locale == 'ge' ? this.$router.push('/ge/cartstep1')
          : this.$router.push('/en/cartstep1');
        }
      }
    },
    mounted() {
      // console.log(this.prevent_gift_match);
      // console.log(this.gift_amount)
      // console.log( this.gift_matched)
      // console.log(this.get_gift_stocks)
      // console.log(this.filter_gift_match)
      // console.log(this.filter_gift_match())
      console.log(this.checkedAdress )
      if (localStorage.getItem('giftStatus') === 'true') {
        this.giftCheck = true
      }
      if(this.$store.state.main.userData !== null)this.addressArr = this.addresses.address;
        setTimeout(() => {
            
        }, 1000);
        this.addressArr = this.addressArr.find(el => el.main_adress === 1)
      if (this.$store.state.main.fullBalance < 1) {
            this.$store.state.main.zero = true
        }
        if (localStorage.getItem('giftCheck') && this.$route.params.path1 === 'cartstep1') {
            // console.log('checked')
            this.clickEvent = true
            this.giftCheck = true
            this.data.giftStatus = true
            this.$store.state.main.fullBalance += parseFloat(this.getgiftPrice);
            this.data.giftItem = this.gift
        }
    },
    watch: {
      gift_amount(ns, os){
        // console.log(ns)
      if(this.checkEvent){

      
        if(ns > os){
          this.$store.state.main.fullBalance = (this.$store.state.main.fullBalance - (this.getgiftPrice * os)) + parseFloat(this.getgiftPrice * ns);
        } else if(ns < os){
          // this.$store.state.main.fullBalance = (this.$store.state.main.fullBalance - os) + parseFloat(this.getgiftPrice);
          this.$store.state.main.fullBalance -= parseFloat(this.getgiftPrice);

        }
        }
      },
      get_store_cart(ns, os){
             let x = JSON.parse(localStorage.getItem('Product'));
       let a = [];
      //  console.log(x)
       x.forEach(_x => {
        //  a.push(_x.ProductObject.slug);
        let stock = _x.ProductObject.stock_items;
        stock.forEach(s => {
         a.push(s[0].id);
        })
       })

        let g_s = this.get_gift_stocks;
          let j;
          g_s.forEach(s => {
          j =  a.includes(s);
          })
          // let j = this.prevent_gift_match.includes(this.get_gift_stocks);
          // console.log(j);
          this.gift_matched = j;

      },
      checkEvent: {
        immediate: true,
        handler: function() {
          if (this.checkEvent) {
            // console.log('checked')
            this.clickEvent = true
            this.data.giftStatus = true
            this.$store.state.main.fullBalance += parseFloat(this.getgiftPrice) * this.gift_amount;
            this.data.giftItem = this.gift
            localStorage.setItem('giftItem', JSON.stringify(this.data.giftItem))
            localStorage.setItem('giftStatus', this.data.giftStatus)
          } else {
            // console.log('unchacked')
            if (this.clickEvent) {
              this.$store.state.main.fullBalance -=  parseFloat(this.getgiftPrice) * this.gift_amount;
              this.data.giftStatus = false
              this.data.giftItem = false
              localStorage.removeItem('giftItem')
              localStorage.setItem('giftStatus', this.data.giftStatus)
            }
          }
        }
      }
    },
    computed: {
      ...mapGetters({ addresses: "main/returnUser" }),
      checkEvent() {
        return this.giftCheck
      },
      get_store_cart(){
        return this.$store.state.main.cart;
      },
        filter_gift_match(){
          let g_s = this.get_gift_stocks;
          let j;
          g_s.forEach(s => {
          j =  this.prevent_gift_match.includes(s);
          })
          // let j = this.prevent_gift_match.includes(this.get_gift_stocks);
          // console.log(j);
          this.gift_matched = j;
          // console.log(this.gift_matched)
           return j;
      },
      get_gift_stocks(){
        let stock = this.contentData.data.list[0].stock_items;
        let b = [];
        stock.forEach(s => {
          b.push(s[0].id);
        })
        return b;
      },
      prevent_gift_match(){
       let x = JSON.parse(localStorage.getItem('Product'));
       let a = [];
      //  console.log(x)
       x.forEach(_x => {
        //  a.push(_x.ProductObject.slug);
        let stock = _x.ProductObject.stock_items;
        stock.forEach(s => {
         a.push(s[0].id);
        })
       })
       return a;
      },
      getDeliveryPrice() {
        var priceArr = this.$store.state.main.indx.terms.customer_cities
        var selectedAdress = this.$store.state.main.currentAdress 
        var res
        if (selectedAdress === null) {
          res = priceArr.find(el => el.slug === this.addressArr.city)
          return parseFloat(_.get(res, 'price')).toFixed(2)
        } else {
          res = priceArr.find(el => el.slug === selectedAdress.city)
          return parseFloat(_.get(res, 'price')).toFixed(2)
        }
      },
      enableBuy() {
        return this.$store.state.main.productLength
      },
      getgiftPrice() {
        if (_.get(this.gift, 'gift_price') !== undefined) {
          // return _.get(this.gift, 'gift_price').toFixed(2)
          return parseFloat(_.get(this.gift, 'gift_price')).toFixed(2);
        }
      },
      getPrice() {
        var num = this.$store.state.main.fullBalance
        if (num < 0) {
          return num = 0
        }
        if (this.$route.params.path1 === 'cartstep1' || this.$route.params.path1 === 'adress') {
          return localStorage.getItem('fullBalance')
        }
        return num.toFixed(2)
      }
    }
}
</script>

<style lang="scss">
.box-res .gift {
}
.box-res .adress-price-cont {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 19.2px;
  position: relative;
  padding-bottom: 21px;
}
.box-res .adress-price-cont .ttl {
  font-size: 16px;
  color: #044B30;
}
.box-res .adress-price-cont::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  border-radius: 50%;
  background-color: #D7DEED;
}
.box-res .adress-price-cont .prc {
  font-size: 16px;
  color: #BACB32;
  margin-top: 8px;
}
.box-res .gift .ttl {
  font-size: 16px;
  color: #BACB32;
  margin-top: 34px;
}
.box-res .gift .inner-g {
  display: flex;
  align-items: center;
  margin-top: 21px;
  justify-content: space-between;
  position: relative;
  padding-bottom: 34px;
}
.box-res .gift .inner-g::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    border-radius: 50%;
    background-color: #D7DEED;
}
.box-res .gift .inner-g .check-cont {
  position: relative;
  width: 24px;
  height: 24px;
}
.box-res .gift .inner-g .check-cont .checkicon {
  transform: translateX(-4px);
  transition: 0.6s;
  opacity: 0;
}
.box-res .gift .inner-g .check-cont .icon-check {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
.box-res .gift .inner-g .check-cont .el-checkbox__inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.box-res .gift .inner-g .el-checkbox.is-checked .checkicon {
  opacity: 1;
}
.box-res .gift .inner-g .image {
  position: relative;
  width: 76px;
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box-res .gift .inner-g .image .bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.box-res .gift .inner-g .gift-price-cont {
  position: relative;
}
.box-res .gift .inner-g .gift-price-cont .gift-price {
  font-size: 21px;
  color: #BACB32;
}
.box-res .gift .inner-g .gift-price-cont .old-price {
  position: absolute;
  top: -15px;
  right: 0;
  font-size: 16px;
  color: #101820;
}
.box-res .gift .inner-g .gift-price-cont .old-price::after {
  content: "";
  width: 100%;
  height: 1px;
  background-color: black;
  left: 0;
  top: 10px;
  position: absolute;
}
.box-res .gift .inner-g .image .img {
  position: relative;
  max-width: 40px;
  max-height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box-res .gift .inner-g .image .bottle {
  position: relative;
  z-index: 2;
  max-width: 27px;
  max-height: 70px;
}
.disableClass {
  opacity: 0.6;
  pointer-events: none;
}
.box-res{
  margin-left: 95px;
  width: 350px;
}
.animClass {
  animation-name: scale-anim;
  animation-delay: 0.6s;
}
.box-res {
  /* border: 1px solid red; */
  position: relative;
  padding-top: 40px;
  /* padding-bottom: 40px; */
  display: flex;
  padding-left: 65px;
  padding-right: 65px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.box-res img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.box-res img:nth-child(2),  .box-res img:nth-child(3), .box-res img:nth-child(4){
  display: none;
}
.box-res .title {
  font-size: 34px;
  color: #044B30;
  position: relative;
  padding-bottom: 22px;
  text-align: center;
}
.box-res .title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  border-radius: 50%;
  background-color: #D7DEED;
}
.box-res .desc {
  font-size: 21px;
  color: #044B30;
  margin-top: 37.7px;
  text-align: center;
}
.box-res .result {
  font-size: 55px;
  margin-top: 16px;
  text-align: center;
  color: #BACB32;
  white-space: nowrap;
  position: relative;
  /* width: 300px; */
}
.box-res .inner {
  padding-bottom: 35px;
  position: relative;
}
.box-res .inner::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  border-radius: 50%;
  background-color: #D7DEED;
}
.box-res button {
  cursor: pointer;
  margin: 34px auto;
  display: flex;
  transition: 0.6s;
  justify-content: center;
  width: 203px;
  height: 56px;
  will-change: transform;
  align-items: center;
  position: relative;
}
.box-res button img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}
.box-res button span {
  position: relative;
  font-size: 21px;
  color: #FFFFFF;
  z-index: 3;
}
.box-res .data-cont {
  position: relative;
  z-index: 5;
  width: 100%;
}
@media (min-width: 1024px) {
   .box-res button:hover {
    transform: scale(1.1) rotate(-2deg);
  }
}

/* Responsive design */
@media (max-width: 1365px) {
  .box-res {
    margin-left: 30px;
    width: 290px;
    padding-left: 35px;
    padding-right: 35px;
    padding-top: 40px;
  }
  .box-res .title::after, .box-res .inner::after {
    left: 50%;
    transform: translateX(-50%);
  }
}
@media (max-width: 1023px) {
  .box-res .title::after, .box-res .inner::after {
    left: 0;
    width: 100%;
    transform: translateX(0px);
  }
  /* .box-res .gift .inner {
    width: 200px !important;
  } */
   .box-res {
    /* width: 100%; */
    /* margin-left: 0px;
    margin-right: 0px; */
    width: 675px;
    margin-left: auto;
    margin-right: auto;
  }
   .box-res {
    margin-top: 114px;
  }
  .box-res .data-cont .inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    position: relative;
  }
  .cartContainer .amount {
    position: relative;
    /* justify-content: center; */
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
      &:after{
       content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  border-radius: 50%;
  background-color: #D7DEED;
    }
    .ttl{
      margin-top: 0;
    }
    .inner{
      width: fit-content;
      &:after{
        display: none;
      }
    }
  
  }
  .box-res img:nth-child(1):not(button img, .box-res .gift .inner-g .image .bg, .box-res .gift .inner-g .image .bottle) {
    display: none;
  }
  .box-res img:nth-child(2) {
    display: flex;
  }
  .box-res {
    justify-content: flex-start;
    align-items: unset;
    padding-left: 55px;
    padding-right: 55px;
   
  }
  .box-res .title {
    text-align: unset;
  }
  .box-res .desc {
    margin-top: 0px;
  }
  .box-res .inner {
    padding-bottom: 14px;
    margin-top: 14px;
  }
   .box-res .result {
    font-size: 34px;
    margin-top: 0px;
    width: unset;
  }
  .box-res button {
    margin: unset;
    margin-top: 21px;
    margin-bottom: 34px;
  }
}
@media (max-width: 767px) {
    .box-res img:nth-child(2) {
    display: none;
  }
    .box-res img:nth-child(3) {
    display: block;
  }
  .box-res .desc {
    font-size: 16px;
  }
  .box-res,
  .box-res .result {
    font-size: 21px;
  }
  .box-res .result {
    margin-top: 16px;
  }
  .box-res .data-cont .inner {
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-start;
  }
  .box-res {
    padding-left: 34px;
    padding-right: 34px;
    padding-top: 59px;
    padding-bottom: 55px;

    /* width: 100%; */
    width: 371px;

  
  }
  .box-res button {
    margin-bottom: 0px;
  }

}

@media (max-width: 413px){
  .box-res{
    width: 277px;
  }
     .box-res img:nth-child(3) {
    display: none;
  }
    .box-res img:nth-child(4) {
    display: block;
  }
}
/* Responsive design */
</style>


<style lang="scss">

.box-res .data-cont{
  display: flex;
  flex-direction: column;
  .title{
    order: 1;
  }
  .inner{
    order: 2;
  }
  .gift{
    order: 3;
  }
  .next{
    order: 4;
  }

}

   
</style>